<script setup lang="ts">
// 1:1 Port von club-member-registration/src/app/app.component: dessen Template ist
// ausschliesslich `<router-outlet></router-outlet>`. Es gibt keine App-Shell — Header, Footer
// und Fortschritts-Gauge gehoeren zur Wizard-Route (`MemberRegistrationView`), nicht hierher.
</script>

<template>
    <RouterView />
</template>
